"use client";

import { useCallback, useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  id: 1,
  name: "Underground Drill Rig",
  room: "Maintenance Overhaul",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_before.png",
  beforeSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_before.png-wvc-srcset",
  beforeSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_before.png-wvc-sizes",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_after.png",
  afterSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_after.png-wvc-srcset",
  afterSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_after.png-wvc-sizes",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_thumb.png",
  thumbSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_thumb.png-wvc-srcset",
  thumbSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_drill_thumb.png-wvc-sizes"
}, {
  id: 2,
  name: "Industrial Pump System",
  room: "Efficiency Upgrade",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_before.png",
  beforeSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_before.png-wvc-srcset",
  beforeSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_before.png-wvc-sizes",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_after.png",
  afterSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_after.png-wvc-srcset",
  afterSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_after.png-wvc-sizes",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_thumb.png",
  thumbSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_thumb.png-wvc-srcset",
  thumbSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_pump_thumb.png-wvc-sizes"
}, {
  id: 3,
  name: "Shaft Lighting",
  room: "LED System Install",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_before.png",
  beforeSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_before.png-wvc-srcset",
  beforeSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_before.png-wvc-sizes",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_after.png",
  afterSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_after.png-wvc-srcset",
  afterSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_after.png-wvc-sizes",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_thumb.png",
  thumbSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_thumb.png-wvc-srcset",
  thumbSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_lighting_thumb.png-wvc-sizes"
}, {
  id: 4,
  name: "Welding Station",
  room: "Facility Modernization",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_before.png",
  beforeSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_before.png-wvc-srcset",
  beforeSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_before.png-wvc-sizes",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_after.webp",
  afterSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_after.webp-wvc-srcset",
  afterSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_after.webp-wvc-sizes",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_thumb.png",
  thumbSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_thumb.png-wvc-srcset",
  thumbSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_welding_thumb.png-wvc-sizes"
}, {
  id: 5,
  name: "Ventilation Fan",
  room: "Airflow Optimization",
  beforeImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_before.png",
  beforeSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_before.png-wvc-srcset",
  beforeSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_before.png-wvc-sizes",
  afterImage: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_after.png",
  afterSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_after.png-wvc-srcset",
  afterSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_after.png-wvc-sizes",
  thumb: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_thumb.png",
  thumbSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_thumb.png-wvc-srcset",
  thumbSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694695/img/mining_fan_thumb.png-wvc-sizes"
}];
export default function Imageshowcase() {
  const [activeId, setActiveId] = useState(projects[0].id);
  const [sliderPos, setSliderPos] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const activeProject = projects.find(p => p.id === activeId) || projects[0];
  const updateFromClientX = useCallback((clientX: number) => {
    const node = containerRef.current;
    if (!node) return;
    const rect = node.getBoundingClientRect();
    const pct = (clientX - rect.left) / rect.width * 100;
    let next = Math.max(0, Math.min(100, pct));
    if (Math.abs(next - 50) < 3) next = 50;
    setSliderPos(next);
  }, []);
  useEffect(() => {
    if (!isDragging) return;
    const handleMove = (e: MouseEvent | TouchEvent) => {
      const clientX = "touches" in e ? e.touches[0]?.clientX ?? 0 : (e as MouseEvent).clientX;
      updateFromClientX(clientX);
    };
    const handleUp = () => setIsDragging(false);
    window.addEventListener("mousemove", handleMove);
    window.addEventListener("touchmove", handleMove, {
      passive: true
    });
    window.addEventListener("mouseup", handleUp);
    window.addEventListener("touchend", handleUp);
    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("mouseup", handleUp);
      window.removeEventListener("touchend", handleUp);
    };
  }, [isDragging, updateFromClientX]);
  const handleProjectChange = (id: number) => {
    setActiveId(id);
    setSliderPos(50);
  };
  return;
}